<template>
  <div class="bg-white px-3 index">
    <div class="add_tits" ref="title">
      <el-form class="form-inlines" :inline="true">
        <el-form-item label="日期:">
          <el-date-picker v-model="formData.time" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" size="small" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="咨询状态">
          <el-select v-model="zxstatus_value" placeholder="请选择" clearable size="small">
            <el-option v-for="item in zxstatus_options" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="咨询方式">
          <el-select v-model="zxtype_value" placeholder="请选择" clearable size="small">
            <el-option v-for="item in zxtype_options" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="咨询来源">
          <el-select v-model="zxsource_value" placeholder="请选择" clearable size="small">
            <el-option v-for="item in zxsource_options" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="职称:">
          <el-cascader :options="formData.job_options" v-model="formData.jobname" clearable size="small"
            :props="{ value: 'id', label: 'name', children: 'children' }"></el-cascader>
        </el-form-item>
        <el-form-item label="科室:">
          <el-cascader :options="formData.ks_options" v-model="formData.ksname" clearable size="small"
            :props="{ value: 'id', label: 'name', children: 'children' }"></el-cascader>
        </el-form-item>
        <el-form-item label="支付方式">
          <el-select v-model="zhifu_value" placeholder="请选择" clearable size="small">
            <el-option v-for="item in zhifu_options" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select v-model="dingdan_value" placeholder="请选择" clearable size="small">
            <el-option v-for="item in dingdan_options" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="医生">
          <el-input v-model="yisheng_value" placeholder="请输入医生姓名" size="small"></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="is_fictitious_user" placeholder="请选择" clearable size="small">
            <el-option v-for="item in type_options" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-printer" size="small" plain @click="openExportExcel">导出
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="ibox-content">
      <el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable">
        <el-table-column v-for="(item, ind) in header" :key="ind" :label="item.name" align="center">
          <el-table-column v-show="item.child.length > 0" v-for="iteme in item.child" :key="iteme.key"
            :label="iteme.name" show-overflow-tooltip>
            <template slot-scope="{ row }">
              <div v-if="iteme.name2">
                <el-link type="primary" @click="getxx(row)">详情</el-link>
              </div>
              <div v-else>{{ row[iteme.key] }}</div>
            </template>
          </el-table-column>
          <template slot-scope="{ row }" v-if="item.child.length < 1">
            {{ row[item.key] }}
          </template>
        </el-table-column>
      </el-table>
      <div class="u-f u-ac u-jsb ft_mr">
        <div></div>
        <div>
          <el-pagination @size-change="handleSizeChanges" @current-change="handleCurrentChanges"
            :current-page="currentPages" :page-sizes="[15, 30, 50, 100]" :page-size="pagesizes"
            layout="total, sizes, prev, pager, next, jumper" :total="counts">
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="聊天记录" :visible.sync="dialogVisible" class="dialogs" center width="40%" top="10px">
      <el-divider></el-divider>
      <div style="padding: 5px 15px">
        <div class="b_xx">
          详细病情：<span v-if="b_xx_info">{{ b_xx_info.describe }}</span>
        </div>
        <div class="b_imgs u-f">
          <div>图片：</div>
          <div class="u-f u-ac" v-if="b_xx_info">
            <el-image v-for="(img, index) in b_xx_info.file_info" :key="index"
              style="width: 80px; height: 80px; margin-right: 5px" :src="img.url" :preview-src-list="[img.url]">
            </el-image>
          </div>
        </div>
      </div>
      <el-divider></el-divider>
      <div class="dialog-ibox-content" :style="{height:listheight}" style="overflow:auto;">
        <div style="max-width: 500px; overflow: auto">
          <div v-for="(item, index) in list" :key="index" class="rec_wp">
            <div class="u-f">
              <div>
                <img :src="item.avatar" alt="" width="50" height="50" class="imgs" />
              </div>
              <div>
                <div>{{ item.create_time }}</div>
                <div>
                  <span v-if="item.msg_type!='image'">{{ item.send_context }}</span>
                  <div v-else-if="item.msg_type=='image'">
                    <el-image 
                    style="width: 80px; height: 80px; margin-right: 5px" :src="item.send_context" :preview-src-list="[item.send_context]">
                  </el-image>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div style="margin-top: 10px" class="u-f u-ac u-jsb">
          <div></div>
          <el-pagination background layout="prev, pager, next" :total="count" small :page-size="pagesize"
            :current-page="page" @current-change="handleCurrentChange"></el-pagination>
        </div> -->
      </div>
      <el-divider></el-divider>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 导出 -->
    <el-dialog title="导出数据" :visible.sync="exportModal" center width="30%">
      <el-form :model="exportForm" ref="ruleForm">
        <el-form-item label="时间范围" required>
          <el-date-picker size="small" v-model="exportForm.time" type="daterange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exportModal = false">取 消</el-button>
        <el-button type="primary" :loading="exporloading" @click="exportExcel">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
  import {
    mapState
  } from "vuex";
  export default {
    data() {
      return {
        formData: {
          time: [],
        },
        loading: false,
        tableData: [],
        header: [],
        heights: null,
        listheight: null,
        //分页
        counts: 0,
        currentPages: 1,
        pagesizes: 15,
        //
        dialogVisible: false,
        count: 0,
        list: [],
        page: 1,
        pagesize: 10,
        loadings: false,
        objxx: "",
        exportForm: {
          time: [],
        },
        exportModal: false,
        exporloading: false,
        zxstatus_options: [{
            id: 1,
            name: "已接诊",
          },
          {
            id: 2,
            name: "未接诊",
          },
        ],
        zxtype_options: [{
            id: 1,
            name: "图文咨询",
          },
          {
            id: 2,
            name: "电话咨询",
          },
          {
            id: 3,
            name: "视频咨询",
          },
        ],
        zxsource_options: [{
            id: 1,
            name: "线上咨询",
          },
          {
            id: 2,
            name: "用户报道",
          },
        ],
        //职称-科室
        formData: {
          job_options: [],
          ks_options: [],
          jobname: "",
          ksname: "",
        },
        //支付
        zhifu_options: [{
            id: 1,
            name: "优惠券支付",
          },
          {
            id: 2,
            name: "微信支付",
          },
        ],
        //订单
        dingdan_options: [{
            id: -1,
            name: "未支付",
          },
          {
            id: 1,
            name: "待接诊",
          },
          {
            id: 2,
            name: "未支付取消",
          },
          {
            id: 3,
            name: "进行中",
          },
          {
            id: 4,
            name: "已完成",
          },
          {
            id: 5,
            name: "已支付取消",
          },
        ],
        is_fictitious_user: '',
        type_options: [{
            id: 1,
            name: '虚拟用户'
          },
          {
            id: 2,
            name: '真实用户'
          },
        ],
        zxsource_value: "",
        zxtype_value: "",
        zxstatus_value: "",
        dingdan_value: '',
        yisheng_value: "",
        zhifu_value: "",
        b_xx_info: "",
      };
    },
    computed: {
      ...mapState({
        user: (state) => state.user.user,
      }),
    },
    mounted() {
      let that = this;
      that.search();
      that.getHeight();
      that.getjob();
      that.getks();
    },
    methods: {
      getjob() {
        axios
          .post(
            "/admin/showCompetentList", {}, {
              token: true,
            }
          )
          .then((response) => {
            this.formData.job_options = response.data.data;
            this.formData.job_options = this.IterDelateChildren(
              this.formData.job_options
            );
          })
          .catch((error) => {});
      },
      getks() {
        axios
          .post(
            "/admin/showSectionList", {}, {
              token: true,
            }
          )
          .then((response) => {
            this.formData.ks_options = response.data.data;
            this.formData.ks_options = this.IterDelateChildren(
              this.formData.ks_options
            );
            this.depat_options = this.IterDelateChildren(response.data.data);
          })
          .catch((error) => {});
      },
      IterDelateChildren(arr) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].children) {
            if (arr[i].children.length) {
              this.IterDelateChildren(arr[i].children);
            } else {
              delete arr[i].children;
            }
          }
        }
        return arr;
      },
      // 获取高度
      getHeight() {
        let that = this;
        var title = that.$refs.title.offsetHeight;
        that.heights = window.innerHeight - title - 200 + "px";
        that.listheight = window.innerHeight - 280 + "px";
        window.onresize = () => {
          var title = that.$refs.title.offsetHeight;
          that.heights = window.innerHeight - title - 200 + "px";
        };
      },
      // 搜索
      begin() {
        let that = this;
        that.currentPages = 1;
        that.pagesizes = 15;
        that.search();
      },
      search() {
        let that = this;
        that.loading = true;
        axios
          .post(
            "/admin/Report/getZxmxTable", {
              page: that.currentPages,
              page_count: that.pagesizes,
              date1: this.formData.time ? this.formData.time[0] : "",
              date2: this.formData.time ? this.formData.time[1] : "",
              inquiry_type: this.zxtype_value,
              reception_status: this.zxstatus_value,
              order_source: this.zxsource_value,
              pay_type: this.zhifu_value,
              doc_name: this.yisheng_value,
              department_id: this.formData.ksname[this.formData.ksname.length - 1],
              competent_id: this.formData.jobname[this.formData.jobname.length - 1],
              pay_status: this.dingdan_value,
              is_fictitious_user: this.is_fictitious_user
            }, {
              token: true,
            }
          )
          .then((response) => {
            that.loading = false;
            that.tableData = response.data.list;
            that.header = response.data.header;
            that.counts = response.data.count;
          })
          .catch((error) => {});
      },
      handleSizeChanges(val) {
        let that = this;
        that.pagesizes = val;
        that.search();
      },
      handleCurrentChanges(val) {
        let that = this;
        that.currentPages = val;
        that.search();
      },
      getxx(row) {
        this.dialogVisible = true;
        this.objxx = row;
        this.page = 1;
        this.getMessage();
      },
      getMessage() {
        axios
          .post(
            "/admin/pc/KkysDoctorInquiryLogs/logsRecord", {
              page: this.page,
              page_count: this.pagesize,
              inquiry_id: this.objxx.id,
            }, {
              token: true,
            }
          )
          .then((response) => {
            this.b_xx_info = response.data.data.inquiryData;
            this.list = response.data.data.list;
            this.count = response.data.data.totalCount;
          })
          .catch((error) => {});
      },
      handleCurrentChange(val) {
        this.page = val;
        this.getMessage();
      },
      openExportExcel() {
        this.exportModal = true;
      },
      exportExcel() {
        if (this.exportForm.time.length == 0)
          return this.$message.error("请选择时间范围");
        let val = this.exportForm.time;
        let params = "";
        if (val && Array.isArray(val)) {
          params += `starttime=${val[0]}`;
          params += `&endtime=${val[1]}`;
        }
        let url = `/admin/pc/Excel/zxmxReport2Excel?`;

        this.exporloading = true;
        this.axios
          .post(
            url + params, {}, {
              token: true,
              responseType: "blob",
            }
          )
          .then((res) => {
            if (res.status == 200) {
              this.exportModal = false;
              let url = window.URL.createObjectURL(new Blob([res.data]));
              let link = document.createElement("a");
              link.style.display = "none";
              link.href = url;
              let filename = new Date().getTime() + ".xlsx";
              link.setAttribute("download", filename);
              document.body.appendChild(link);
              link.click();
            } else if (res.data.code != 200) {
              this.$message("暂无数据");
            }
            this.exporloading = false;
          })
          .catch((err) => {
            this.exporloading = false;
          });
      },
    },
  };
</script>


<style scoped>
  .imgs {
    border-radius: 50%;
  }

  .rec_wp {
    padding: 10px;
    border-bottom: 1px solid #f5f5f5;
  }

  .nomores {
    margin-top: 10px;
    font-size: 13px;
    color: #ccc;
    text-align: center;
  }

  .b_xx {
    margin-bottom: 10px;
  }

  .b_imgs {}
</style>